/* Logo drag bounds — derived from the PRINT renderer's own placement math
   (base_w=W*0.30, base_h=H*0.45, lw=base_w*scale; lx=W/2-lw/2+logoX), so a
   logo can never be dragged off the label. Replaces fixed +/-30 and +/-14
   stops that let logoY reach 14 on a 19.05mm label = 0% of the logo on the
   label (order #1490 job 1921). Same paren shape as the constants. */
window.vaLBx=window.vaLBx||function(){var W=(window.vaLabelW||44.958),s=window.logoScale||1,lw=W*0.30*s;return Math.max(0,(W-lw)/2)};
window.vaLBy=window.vaLBy||function(){var H=(window.vaLabelH||19.05),s=window.logoScale||1,lh=H*0.45*s;return Math.max(0,(H-lh)/2)};
/* VialArt — touch gestures for a placed logo on the label preview.
   One finger drags to MOVE it; two fingers PINCH to resize (mirrors the size
   slider). Sets window.__vaGestureV2 AFTER a successful bind so the builder's
   inline drag-only handler stands down (its pointerdown checks that flag) — if
   this file is absent or errors before binding, the flag never sets and the
   original drag still works. Only acts while a logo is placed. Fail-open. */
(function () {
  'use strict';
  function apply() {
    try { if (typeof window.updateFlat === 'function') window.updateFlat(); } catch (e) {}
    try { if (typeof window.scheduleVial === 'function') window.scheduleVial(); } catch (e) {}
  }
  function syncSlider() {
    var pct = Math.round((window.logoScale || 1) * 100);
    var s = document.getElementById('va-logo-scale'), t = document.getElementById('va-logo-scaleval');
    if (s) s.value = pct;
    if (t) t.textContent = pct + '%';
  }
  function bind(fl) {
    // Defer to the builder's own gesture v2 (va-flow2.js sets fl.__vaG2) if it
    // already bound this element — this file is only a fallback where that's absent.
    if (!fl || fl.__vaGz || fl.__vaG2) return false;
    fl.__vaGz = true;
    try { fl.style.touchAction = window.customLogo ? 'none' : 'pan-y pinch-zoom'; fl.style.userSelect = 'none'; fl.style.webkitUserSelect = 'none'; } catch (_) {}
    try { window.addEventListener('va-logo-changed', function () { try { fl.style.touchAction = window.customLogo ? 'none' : 'pan-y pinch-zoom'; } catch (_e) {} }); } catch (_) {}
    var ptrs = {}, n = 0, dg = false, lx = 0, ly = 0, mv = 0, pinchD0 = 0, pinchS0 = 1;
    function unit() { var r = fl.getBoundingClientRect(); var W = (typeof sel !== 'undefined' && sel && sel.w) || 44.45; return r.width ? (W / r.width) : 0.05; }
    function list() { var a = []; for (var k in ptrs) { if (ptrs.hasOwnProperty(k)) a.push(ptrs[k]); } return a; }
    fl.addEventListener('pointerdown', function (e) {
      if (!window.customLogo) return;
      if (!ptrs[e.pointerId]) n++;
      ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (n === 2) { var p = list(); pinchD0 = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y); pinchS0 = window.logoScale || 1; dg = false; }
      else { dg = true; mv = 0; lx = e.clientX; ly = e.clientY; }
      try { fl.setPointerCapture(e.pointerId); } catch (_) {}
      fl.style.cursor = 'grabbing';
      e.preventDefault();
    });
    fl.addEventListener('pointermove', function (e) {
      if (!window.customLogo) return;
      if (ptrs[e.pointerId]) ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (n >= 2 && pinchD0 > 0) {
        var p = list(); var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
        window.logoScale = Math.max(0.4, Math.min(2.2, pinchS0 * (d / pinchD0)));
        syncSlider(); apply(); e.preventDefault(); return;
      }
      if (!dg) return;
      var uu = unit(), pdx = e.clientX - lx, pdy = e.clientY - ly;
      mv += Math.abs(pdx) + Math.abs(pdy);
      window.logoX = Math.max(-window.vaLBx(), Math.min(window.vaLBx(), (window.logoX || 0) + pdx * uu));
      window.logoY = Math.max(-window.vaLBy(), Math.min(window.vaLBy(), (window.logoY || 0) + pdy * uu));
      lx = e.clientX; ly = e.clientY; apply(); e.preventDefault();
    });
    function end(e) {
      if (e && ptrs[e.pointerId]) { delete ptrs[e.pointerId]; n = Math.max(0, n - 1); }
      if (n < 2) pinchD0 = 0;
      if (n === 1) { var r = list()[0]; if (r) { dg = true; lx = r.x; ly = r.y; } }
      if (n === 0) { dg = false; if (mv > 4) { window._vaJustDragged = true; setTimeout(function () { window._vaJustDragged = false; }, 60); } fl.style.cursor = '';
        /* resync the order-summary thumb with the final logo transform */
        try { if (typeof window.renderAll === 'function') window.renderAll(); } catch (_) {} }
    }
    fl.addEventListener('pointerup', end);
    fl.addEventListener('pointercancel', end);
    return true;
  }
  function boot() {
    var ok = false;
    ['va-flatlabel', 'va-flatlabel2'].forEach(function (id) { if (bind(document.getElementById(id))) ok = true; });
    if (ok) window.__vaGestureV2 = true;   // take over only once we're actually wired
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  try { window.addEventListener('va-logo-changed', boot); } catch (e) {}
})();
